import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { MDBInput } from "mdb-react-ui-kit";
import apiService from "../../../Services/apiServices";
import { useToasts } from "react-toast-notifications";
import Search from "../../../PageComponents/Search/Search";
import helper from "../../../Services/helper";
import ExcelExport from "../../../PageComponents/Excel/ExcelExport";
import Print from "../../../PageComponents/Print/Print";
import DataTable from "../../../PageComponents/UI/Tables/DataTable";
import LoaderComponent from "../../../PageComponents/UI/Components/LoaderComponent";



function AssetDepreciation(props) {
    const [findByDate, setFindByDate] = useState({ year: null, month: null, dateStart: null, dateEnd: null, dateStartDisabled: true, dateEndDisabled: true });
    const [items, setItems] = useState([]);
    const [find, setFind] = useState([]);
    const [years, setYears] = useState([{ value: null, label: helper().translate("CHOOSE") }, { value: 2018, label: "2018" }, { value: 2019, label: "2019" }, { value: 2020, label: "2020" }, { value: 2021, label: "2021" }, { value: 2022, label: "2022" }, { value: 2023, label: "2023" }, { value: 2024, label: "2024" }, { value: 2025, label: "2025" }]);
    const { addToast } = useToasts();
    const excelExportRef = useRef();
    const [loader, setLoader] = useState(false);
    const printRef = useRef();
    const searchObj = { CompanyBranch: 0, PurchaseType: -1, StartDate: helper().formatDate(findByDate.dateStart, 'MM-dd-yyyy'), EndDate: helper().formatDate(findByDate.dateEnd, 'MM-dd-yyyy') }
    const months = [
        { value: null, label: helper().translate("CHOOSE") }, { value: 1, label: "Janar" }, { value: 2, label: "Shkurt" }, { value: 3, label: "Mars" },
        { value: 4, label: "Prill" }, { value: 5, label: "Maj" }, { value: 6, label: "Qershor" },
        { value: 7, label: "Korrik" }, { value: 8, label: "Gusht" }, { value: 9, label: "Shtator" },
        { value: 10, label: "Tetor" }, { value: 11, label: "Nëntor" }, { value: 12, label: "Dhjetor" }
    ];

    useEffect(() => {
        getDate();
        getAssetDepreciation(null, null, null, null);
    }, [])

    const exportToExcel = () => {
        // let table = document.getElementById('table-to-xls-1').innerHTML;
        let fileName = helper().translate("ASSET_DEPRECIATION");
        // return helper().exportToExcel(table, fileName)
        excelExportRef.current.exportToExcel(fileName)
    }

    const print = () => {
        // window.open(`#/excel-print?CompanyBranch=${searchQuery.CompanyBranch}&YEAR=${searchQuery.YEAR}&StartMonth=${searchQuery.StartMonth}&EndMonth=${searchQuery.EndMonth}`, 'popUpWindow', 'height=1300,width="100%",left=100,top=100,right=100,bottom=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
        //setOpen(!open)
        printRef.current.printPreview()
    }

    const headers = [
        { key: 'no', columnName: helper().translate("NR"), dontShowMenu: true },
        { key: 'date', columnName: helper().translate("DATE") },
        { key: 'year', columnName: helper().translate("YEAR"), type: "text" },
        { key: 'month', columnName: helper().translate("MONTH"), type: "text" },
        { key: 'invoiceNo', columnName: helper().translate("INVOICE_NO"), type: "text" },
        { key: 'partnerName', columnName: helper().translate("SUBJECT"), type: "text" },
        { key: 'group', columnName: helper().translate("GROUP"), type: "text" },
        { key: 'description', columnName: helper().translate("DESCRIPTION"), type: "comment" },
        { key: 'category', columnName: helper().translate("CATEGORY"), type: "text" },
        { key: 'total', columnName: helper().translate("TOTAL"), type: "number" },
        { key: 'depreciationRate', columnName: helper().translate("DEPRECIATION_RATE"), type: "number" },
        { key: 'depreciation', columnName: helper().translate("DEPRECIATION"), type: "number" }
    ];
    const getAssetDepreciation = (year, month, dateStart, dateEnd) => {
        setLoader(true);
        let strStartDate = helper().formatDate(dateStart, 'MM-dd-yyyy');
        let strEndDate = dateEnd ? helper().formatDate(dateEnd, 'MM-dd-yyyy') + " 23:59:59" : null;
        var params = `&year=${year}&month=${month}&dateStart=${strStartDate}&dateEnd=${strEndDate}`;
        apiService()
            .query('getAssetDepreciation', params)
            .then((response) => {
                if (response.success) {
                    setLoader(false);
                    var items = response.data.slice(1);
                    var previusSaldo = 0.00;

                    let num = 1;
                    items?.forEach(e => {
                        e.no = num++;
                        let inOut = e?.debi - e?.credi;
                        e.saldo = (parseFloat(inOut) + parseFloat(previusSaldo)).toFixed(2);
                        e.date = helper().formatDate(e.date);
                        e.debi = e?.debi?.toFixed(2);
                        e.credi = e?.credi?.toFixed(2);
                        previusSaldo = e.saldo;
                        e.month = months.find(m => m.value == e.month)?.label;
                    });

                    setFind(items);
                    setItems(items);
                } else {
                    console.log('Error:' + response.errorMessage);
                }
            });
    }

    const getDate = () => {
        const dateTimeNow = new Date();

        const dateTimeStart = new Date(
            dateTimeNow.getFullYear() - 1,
            dateTimeNow.getMonth(),
            dateTimeNow.getDate()
        );

        setFindByDate({
            ...findByDate,
            dateStart: dateTimeStart,
            dateEnd: dateTimeNow
        });
    };


    const searchBtn = () => {
        let dateStart = findByDate.dateStart;
        let dateEnd = findByDate.dateEnd;

        if (findByDate.dateStartDisabled === false) {
            dateStart = null;
        } else if (findByDate.dateEndDisabled === false) {
            dateEnd = null;
        }
        getAssetDepreciation(findByDate.year, findByDate.month, dateStart, dateEnd)
    }

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            background: "#fff",
            borderColor: "#9e9e9e",
            minHeight: "28.59px",
            height: "28.59px",
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: "28.59px",
            padding: "0 6px",
        }),

        input: (provided, state) => ({
            ...provided,
            margin: "0px",
        }),
        indicatorSeparator: (state) => ({
            display: "none",
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: "28.59px",
        }),
    };
    const fieldChange = (e) => {
        if (e.target.name === "dateStart") {
            setFindByDate({ ...findByDate, dateStart: e.target.value + " 00:00:00" });
        } else
            if (e.target.name === "dateEnd") {
                setFindByDate({ ...findByDate, dateEnd: e.target.value + " 23:59:59" });

            }
    };

    const selectChange = (e, obj) => {
        if (obj.name === "year") {
            setFindByDate({ ...findByDate, year: e.value })
        } else if (obj.name === "month") {
            setFindByDate({ ...findByDate, month: e.value })
        }
    };

    const findChange = (e) => {
        if (e.target.value == "") {
            setFind(items);
        }
        var searchItems;
        let searchString = e.target.value.trim().toLowerCase();

        if (searchString.length > 0) {
            searchItems = items.filter((item) => {
                return (
                    item?.documentId?.toString().toLowerCase().match(searchString) ||
                    item?.companyName?.toString().toLowerCase().match(searchString)
                );
            });
            if (searchItems.length > 0) {
                setFind(searchItems);
            } else {
                setFind(items);
            }
        }
    };


    return (
        <div className="container-fluid px-2 mt-3">
            <Search change={(e) => findChange(e)} excel={() => exportToExcel()} printClick={print} back="#/reportsMap/7" />
            <ExcelExport data={find.length ? find : []} headers={headers} type={'other'} ref={excelExportRef} hideContent={true} />
            <Print data={find.length ? find : []} headers={headers} ref={printRef} query={searchObj} reportName={helper().translate("BANK_BOOK")} />
            <div className="card border-left-primary shadow h-100 mt-1">
                <div className="card-body pt-3 pb-1">
                    <div className="row">
                        <div className="col-11">
                            <div className="row no-gutters align-items-center">
                                <div className="col row">
                                    <div className="col-lg-3 mb-3 mb-md-0 pe-0 d-flex align-items-center">

                                        <div style={{ width: '5%' }}>
                                            <input type="checkbox" name="includeStartDate" checked={findByDate.dateStartDisabled} onChange={(e) => setFindByDate({ ...findByDate, dateStartDisabled: e.target.checked })} ></input>
                                        </div>
                                        <div style={{ width: '95%' }}>
                                            <MDBInput
                                                name="dateStart"
                                                disabled={!findByDate.dateStartDisabled}
                                                className="form-control-sm active"
                                                onChange={(e) => setFindByDate({ ...findByDate, dateStart: new Date(e.target.value) })}
                                                type="date"
                                                label={helper().translate("START_DATE")}
                                                value={helper().isValidDate(findByDate.dateStart) ? findByDate.dateStart.toISOString().substring(0, 10) : ''}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mb-3 mb-md-0 pe-0 d-flex align-items-center">
                                        <div style={{ width: '5%' }}>
                                            <input type="checkbox" name="includeStartDate" checked={findByDate.dateEndDisabled} onChange={(e) => setFindByDate({ ...findByDate, dateEndDisabled: e.target.checked })} ></input>
                                        </div>
                                        <div style={{ width: '95%' }}>
                                            <MDBInput
                                                name="dateEnd"
                                                disabled={!findByDate.dateEndDisabled}
                                                className="form-control-sm active"
                                                onChange={(e) => setFindByDate({ ...findByDate, dateEnd: new Date(e.target.value) })}
                                                type="date"
                                                label={helper().translate("END_DATE")}
                                                value={helper().isValidDate(findByDate.dateEnd) ? findByDate.dateEnd.toISOString().substring(0, 10) : ''}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ paddingTop: "2px" }} className="col-lg-3 mb-3 mb-md-0 pe-0 ">
                                        <Select
                                            name="year"
                                            placeholder={helper().translate("YEAR")}
                                            styles={selectStyles}
                                            options={years}
                                            onChange={(e, obj) => selectChange(e, obj)}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "2px" }} className="col-lg-3 mb-3 mb-md-0 pe-0 ">
                                        <Select
                                            name="month"
                                            placeholder={helper().translate("MONTH")}
                                            styles={selectStyles}
                                            options={months}
                                            onChange={(e, obj) => selectChange(e, obj)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-1 col-12 d-flex align-items-center justify-content-center  justify-content-lg-end">
                            <div>
                                <a className="searchbutton" onClick={() => searchBtn()}>
                                    <i className="fas fa-search fa-2x text-dark" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card shadow mt-1">
                <div className="card-header py-2"><h6 className="m-0 font-weight-bold text-primary text-center">{helper().translate("LIST_OF_ASSETS")}</h6></div>
                {loader && <LoaderComponent />}
                {!loader ? find.length ? <DataTable data={find} headers={headers} formName="assetDepreciationRpt" /> : <div className="p-5 text-center">{helper().translate("NO_DATA")}</div> : ""}
            </div>
        </div>

    )
}

export default AssetDepreciation;
